// 该类存放项目中所有公共正则表达式判断  可以通过 vue.$regular来使用该类的方法
class regular {
  isMobileNumber (mobile) { // 是否是手机号
    const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    return reg.test(mobile);
  };
  isPassword (password) { // 是否是密码  6-20位，只能由数字，字母，下划线组成
    const reg = /^[\w]{6,20}$/;
    return reg.test(password);
  }
}
// export regular类的对象
export default new regular();



// WEBPACK FOOTER //
// ./src/utils/regular.js